export enum FormTemplateSectionTypeEnum {
    Standard = 1,
    Consent = 2,
    PersonalInformation = 3,
    Questionnaire = 4
}
